'use es6';

import { combineReducers } from 'redux';
import PublicAchievement from './PublicAchievement';
export default combineReducers({
  achievement: PublicAchievement
});